import { SaveTaskDto } from 'actions/tasks/TasksDtos';
import { isFeedingTask, isMedicationTask, SaveTask } from 'types/Task';

export const convertToSaveTaskDto = (task: SaveTask): SaveTaskDto => {
    if (isMedicationTask(task)) {
        return {
            task_type: 2,
            uuid: task.uuid,
            dosage_amount: task.dosage.quantity.toString(),
            dosage_unit_id: task.dosage.unit,
            medication_instructions: task.instructions,
            medication_method_id: task.methodType,
            medication_name: task.name,
            task_date: task.date.toISOString()
        };
    }

    if (isFeedingTask(task)) {
        return {
            task_type: 1,
            uuid: task.uuid,
            feeding_instructions: task.instructions,
            feeding_moment_type_id: task.momentTypeId,
            food_brand: task.brand ?? '',
            food_provision_type_id: task.foodProvisionType,
            food_quantity: task.quantity.quantity.toString(),
            food_quantity_unit_id: task.quantity.unit,
            food_type_id: task.foodType,
            task_date: task.date.toISOString()
        };
    }

    throw new Error('Invalid task type');
};
